import {Component} from '@angular/core';
import {Events, NavController, NavParams, Platform} from 'ionic-angular';
import {HttpClient} from "@angular/common/http";
import {ApiErrorHandlerProvider} from "../../providers/api-error-handler/api-error-handler";
import {ProfileLoginPage} from "../profile-login/profile-login";
import {PushNotificationServiceProvider} from "../../providers/push-notification-service/push-notification-service";
import {StripeServiceProvider} from "../../providers/stripe-service/stripe-service";
import {TermsConditionsServiceProvider} from "../../providers/terms-conditions-service/terms-conditions-service";
import {InAppBrowser} from "@ionic-native/in-app-browser";
import {UrlServiceProvider} from "../../providers/url-service/url-service";

@Component({
  selector: 'page-profile-create-account',
  templateUrl: 'profile-create-account.html',
})
export class ProfileCreateAccountPage {

  errors: {};
  loading: boolean;
  name: string;
  email: string;
  phone: string;
  password: string;
  password_confirmation: string;
  terms: boolean;
  privacy: string;
  termsConditions: string;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public events: Events,
    private http: HttpClient,
    private pushService: PushNotificationServiceProvider,
    private apiErrorHandler: ApiErrorHandlerProvider,
    private stripeService: StripeServiceProvider,
    private termsConditionsService: TermsConditionsServiceProvider,
    public urlService: UrlServiceProvider,
    private platform: Platform,
  ) {
    this.privacy = '#';
    this.termsConditions = '#';
  }

  ngOnInit() {
    this.termsConditionsService.getPrivacyPolicy().then((url: string) => {
      this.privacy = url;
    });

    this.termsConditionsService.getRegisterCustomer().then((url: string) => {
      this.termsConditions = url;
    });
  }

  register() {
    this.loading = true;

    this.http.post('/register', {
      name: this.name,
      email: this.email,
      phone: this.phone,
      password: this.password,
      password_confirmation: this.password_confirmation,
      terms: this.terms,
    }).subscribe((data: any) => {

      // Set user details to the localStorage
      localStorage.setItem('tuid', data.id);
      localStorage.setItem('accountType', data.account_type);
      localStorage.setItem('currentTeamId', data.current_team_id);
      localStorage.setItem('lastBookingTeamId', data.last_booking_team_id);

      // Create a login event
      this.events.publish('user:login');

      this.stripeService.registerWithStripe().then(() => {
        const lastStep = () => {
        // Redirect to the user profile page
        this.navCtrl.push(ProfileLoginPage, {'tuid': data.id}).then(()=>{
          this.name = null;
          this.email = null;
          this.phone = null;
          this.password = null;
          this.password_confirmation = null;
          this.terms = false;
          this.errors = {};
          this.loading = false;
        });
      }

      if (!this.platform.is('cordova')) {
        lastStep();
      } else {
        this.pushService.registerForPush().then(lastStep);
      }
      });
    }, error => {
      this.loading = false;
      this.errors = this.apiErrorHandler.handleError(error);
      console.log(error);
    }, () => {
    });
  }

}



// WEBPACK FOOTER //
// ./src/pages/profile-create-account/profile-create-account.ts